import React, { Component } from 'react'
import DefaultLayout from '../../../../Layout/Default'
import Box from '../../../../../Shared/Box'
import './styles.scss'
import { withTranslation } from 'react-i18next'
import CustomerEdit from '../../../../../Shared/Customer/Edit'
import { adminGetSubscription, saveCustomer } from '../../../../../../api'
import Loader from '../../../../../Shared/Loader'
import Alert from '../../../../../Shared/Alert'

class OrderCustomerEdit extends Component {

  constructor (props) {
    super(props)

    this.state = {
      loading: false,
      order: null,
      initialized: true,
      error: null
    }

    this.abortControllerOrder = null
    this.abortControllerCustomerSave = null
  }

  componentDidMount () {
    this.getOrder(this.props.match.params.id)
  }

  componentWillUnmount () {
    if (this.abortControllerOrder !== null) {
      this.abortControllerOrder.abort()
    }
    if (this.abortControllerCustomerSave !== null) {
      this.abortControllerCustomerSave.abort()
    }
  }

  onCancel = () => {
    this.props.history.push('/admin/orders/' + this.props.match.params.id)
  }

  onSave = (customer) => {
    if(this.abortControllerCustomerSave !== null) {
      this.abortControllerCustomerSave.abort()
    }
    this.abortControllerCustomerSave = new AbortController()
    let order = { ...this.state.order }
    order.customer = customer
    this.setState({ loading: true, error: null }, async () => {
      try {
        let savedCustomer = await saveCustomer(customer.id, customer, this.abortControllerCustomerSave).fetchPromise
        let order = { ...this.state.order }
        order.customer = savedCustomer
        this.setState({ loading: false, order })
        // this.onCancel()
      } catch (e) {
        this.setState({ loading: false, error: 'Failed to save customer' })
        window.scrollTo(0, 0)
      }
    })
  }

  getOrder (id) {
    if(this.abortControllerOrder !== null) {
      this.abortControllerOrder.abort();
    }
    this.abortControllerOrder = new AbortController()
    this.setState({ loading: true, order: null, error: null }, () => {
      adminGetSubscription(id, this.abortControllerOrder)
        .fetchPromise.then((response) => {
        this.setState({ order: response, loading: false })
      }).catch(() => {
        if (this.abortControllerOrder.signal.aborted) {
          return
        }
        this.setState({ loading: false, error: 'Failed to get order' })
      })
    })
  }

  render () {
    const { t } = this.props

    return (
      <DefaultLayout>
        <div className="customerEditPage">
          {this.state.loading && <Loader size={32}/>}
          <Box style={{ position: 'relative' }} hasInnerBackground={true}>
            {this.state.error && <Alert type={'danger'}>{this.state.error}</Alert>}
            {this.state.order &&
            <CustomerEdit customer={this.state.order.customer} onCancel={this.onCancel} onSave={this.onSave}
                          saveLabel={t('SAVE')} cancelLabel={t('CANCEL')}
                          winlineId={true} isAdminUI={true}
            />
            }
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

export default withTranslation()(OrderCustomerEdit)
